import httpRequest from './http-request';
import { handleLearningRequest } from './util';

/**
 * 用户相关一定不走cdn，kae内网的可以不走cdn
 */
class Learning {
  constructor() {
    // 服务端用https请求会失败，原因未明
    const protocol = process.server ? 'http:' : '';

    this.domain = `${protocol}//learning.u.wps.cn`;
    this.cdnDomain = `${protocol}//learning.u.wpscdn.cn`;

    this.wpsDomain = `${protocol}//learning.u.wps.cn`;
    this.adminDomain = `${protocol}//admin.learning.wps.cn`;
    this.feedbackDomain = `${protocol}//qa.wps.cn`;
  }

  // 获取顶部菜单接口
  async getMenu() {
    const url = `${this.cdnDomain}/common/menu`;
    return handleLearningRequest(await httpRequest.query({ url }));
  }

  // 获取底部友情链接、相关等模块
  async getLinks() {
    const url = `${this.cdnDomain}/common/links`;
    return handleLearningRequest(await httpRequest.query({ url }));
  }

  // 获取站点信息
  async getSiteInfo() {
    const url = `${this.cdnDomain}/common/site_info`;
    return handleLearningRequest(await httpRequest.query({ url }));
  }

  async getFooterLinks() {
    const url = `${this.cdnDomain}/v2/common/footer/links`;
    return handleLearningRequest(await httpRequest.query({ url }));
  }

  // 获取热门搜索
  async getHotWords() {
    const url = `${this.cdnDomain}/v2/common/pc_hotwords`;
    return handleLearningRequest(await httpRequest.query({ url }));
  }

  // 获取二级系列课教程
  async getNcreCourse(id) {
    const url = `${this.cdnDomain}/ncre/course/${id}`;
    return handleLearningRequest(await httpRequest.query({ url }));
  }

  // 获取二级系列课信息
  async getNcreSeries(sid) {
    const url = `${this.cdnDomain}/ncre/series/${sid}`;
    return handleLearningRequest(await httpRequest.query({ url }));
  }

  // 获取二级系列课预览数据
  async getNcrePreviewCourse(id) {
    const url = `${this.adminDomain}/ncre/course_preview/detail?id=${id}`;
    return handleLearningRequest(await httpRequest.query({ url }));
  }

  // 获取二级系列课预览信息
  async getNcrePreviewSeries(sid) {
    const url = `${this.adminDomain}/ncre/course_preview/series?sid=${sid}`;
    return handleLearningRequest(await httpRequest.query({ url }));
  }

  // 获取搜索联想词
  async getSearchAssociate(key) {
    const deviceId = localStorage.getItem('dw_store_device_id_key');
    return await httpRequest.query({
      url: `${this.domain}/search/resource/academy/associate`,
      options: {
        method: 'post',
        data: { key, device_id: deviceId },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      },
    });
  }

  //获取反馈中心后台状态
  async sendCenterFeedback(data) {
    let article = JSON.stringify(data);
    data = { article };
    const url = `${this.feedbackDomain}/articles`;
    const options = {
      method: 'post',
      data,
    };
    return await httpRequest.query({ url, options });
  }

  /**
   * 获取我的收藏的数据
   * @param {*} type 收藏类型 1 电脑版技巧 11 移动版技巧 2文章
   * @param {*}
   */
  async getUserFav({ type = 1, search = '', limit = 10, page = 1 }) {
    const url = `${
      this.wpsDomain
    }/user/${type}/fav?page=${page}&limit=${limit}&search=${search}&_=${Date.now()}`;
    return handleLearningRequest(
      await httpRequest.query({ url, options: { withCredentials: true } })
    );
  }

  /**
   * 获取我的订阅的数据
   * @param {*} type
   */
  async getUserSubscribe({ page = 1, limit = 10 }) {
    const url = `${this.domain}/v2/user_subscribe/?page=${page}&page_size=${limit}`;
    return handleLearningRequest(
      await httpRequest.query({ url, options: { withCredentials: true } })
    );
  }

  /**
   * 收藏
   * @param {*} id
   */
  async doFav(id) {
    const url = `${this.wpsDomain}/user/${id}/do_fav`;
    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        withCredentials: true,
      },
    });
  }

  /**
   * 获取某个文章、视频的点赞收藏情况
   * @param {*} id
   */
  async getLikeFavState(id) {
    const url = `${this.wpsDomain}/v2/user/like_fav/${id}`;

    return handleLearningRequest(
      await httpRequest.query({
        url,
        options: {
          withCredentials: true,
        },
      })
    );
  }

  /**
   * 获取用户对系列课的订阅状态
   * @param {*} sid 系列课id
   * @param {*} id 课程id
   */
  async getSubState(sid, id) {
    const url = `${this.wpsDomain}/v2/user/is_sub/${sid}/${id}`;

    return handleLearningRequest(
      await httpRequest.query({ url, options: { withCredentials: true } })
    );
  }

  /**
   * 取消收藏
   * @param {*} id
   */
  async doUnFav(id) {
    const url = `${this.wpsDomain}/user/${id}/do_unfav`;
    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        withCredentials: true,
      },
    });
  }

  /**
   * 点赞
   * @param {*} id
   */
  async doLike(id) {
    const url = `${this.wpsDomain}/user/${id}/do_like`;
    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        withCredentials: true,
      },
    });
  }

  /**
   * 取消点赞
   * @param {*} id
   */
  async doUnLike(id) {
    const url = `${this.wpsDomain}/user/${id}/do_unlike`;
    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        withCredentials: true,
      },
    });
  }

  /**
   * 订阅
   * @param {*} subjectId
   * @param {*} postId
   */
  async doSub(subjectId, postId) {
    const url = `${this.wpsDomain}/v3/user/${subjectId}/do_sub`;
    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        data: {
          postid: postId,
        },
        withCredentials: true,
      },
    });
  }

  /**
   * 取消订阅
   * @param {*} subjectId
   * @param {*} postId
   */
  async doUnSub(subjectId, postId) {
    const url = `${this.wpsDomain}/v3/user/${subjectId}/do_unsub`;
    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        data: {
          postid: postId,
        },
        withCredentials: true,
      },
    });
  }

  /**
   * 提交反馈
   */
  async submitFeedback({ feedback, fromChannel, searchResult, hash }) {
    const url = `${this.wpsDomain}/feedback`;

    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        data: {
          from_channel: fromChannel,
          feedback,
          search_result: searchResult,
          __hash__: hash,
        },
        withCredentials: true,
      },
    });
  }

  /**
   * 提交评价
   */
  async submitComment({ content, fromChannel, id, isHelp, ext, token }) {
    const url = `${this.wpsDomain}/comment`;

    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        data: {
          content,
          id,
          is_help: isHelp,
          ext,
          from_channel: fromChannel,
          __c_token__: token,
        },
        withCredentials: true,
      },
    });
  }

  /**
   * 获取提交反馈得token
   */
  async getFbToken() {
    const url = `${this.wpsDomain}/v2/fb_token`;
    const res = await httpRequest.query({ url, options: { withCredentials: true } });
    if (res.code === 200 && res.data && res.data.__hash__) {
      return res.data.__hash__;
    } else {
      return '';
    }
  }

  /**
   * 获取文章详情页的数据
   * @param {*} id
   * @param {*} isPreview 是否预览
   */
  async getArticleDetail(id, isPreview) {
    const url = isPreview
      ? `${this.adminDomain}/preview/ssr_article_preview/detail_for_ssr?id=${id}`
      : `${this.cdnDomain}/v2/detail/article/${id}`;

    return handleLearningRequest(await httpRequest.query({ url }));
  }

  /**
   * 获取视频教程详情页的数据
   * @param {*} id
   * @param {*} sid
   * @param {*} isPreview 是否预览
   */
  async getCourseDetail(id, sid, isPreview) {
    const url = isPreview
      ? `${
        this.adminDomain
      }/preview/ssr_course_preview/detail_for_ssr?id=${id}${
        sid ? `&sid=${sid}` : ''
      }`
      : `${this.cdnDomain}/v2/common/course/${id}${sid ? `/${sid}` : ''}`;
    const data = await httpRequest.query({
      url,
    });

    return handleLearningRequest(data);
  }

  /**
   * 获取视频详情页所有运营位数据
   * @param {*} id 视频教程id
   */
  async getCourseOpData(id) {
    const url = `${this.cdnDomain}/v2/op/course_total/${id}`;
    return handleLearningRequest(
      await httpRequest.query({
        url,
      })
    );
  }

  /**
   * 获取文章详情页的所有运营位数据（目前只有底部相关文章）
   * @param {*}} id 文章页id
   */
  async getArticleOpData(id) {
    const url = `${this.cdnDomain}/v2/op/article_total/${id}`;
    return handleLearningRequest(await httpRequest.query({ url }));
  }

  /**
   * 获取视频结束后的推荐数据
   */
  async getCourseEndData(cate) {
    const url = `${this.cdnDomain}/academy/operator/basic_course/detailpage_video_over_${cate}_recommend`;

    return handleLearningRequest(await httpRequest.query({ url }));
  }

  /**
   * 获取视频详情进阶技巧
   */
  async getAdvanceCourses() {
    const url = `${this.cdnDomain}/academy/operator/basic_course/detailpage_advance_recommend`;

    return handleLearningRequest(await httpRequest.query({ url }));
  }

  /**
   * 获取个人已学技巧、已学文章数
   */
  async getUserReadNum() {
    const url = `${this.wpsDomain}/v2/user/read_num`;

    return handleLearningRequest(
      await httpRequest.query({
        url,
        options: { withCredentials: true },
      })
    );
  }

  /**
   * 获取个人已学技巧、已学文章数(新版上报逻辑)
   */
  async getUserLearngingDetail() {
    const url = `${this.domain}/v2/userpostread/index`;
    return handleLearningRequest(
      await httpRequest.query({
        url,
        options: { withCredentials: true },
      })
    );
  }

  /**
   * 获取消息列表
   * @param status 是否已读
   * 0. 已读
   * 1. 未读
   * @param category 消息类别
   * 1. sys -> 系统消息
   * 2. all -> 全部信息
   * 3. act -> 活动消息
   * @param data
   * @returns {Promise<any>}
   */
  async getMsgList({ status = 0, category = 'all', data }) {
    const url = `${this.wpsDomain}/msg/${status}/list/${category}`;

    return handleLearningRequest(
      await httpRequest.query({
        url,
        options: {
          data,
          withCredentials: true,
        },
      })
    );
  }

  /**
   * 消息已读
   * @param {Array} ids 对应消息id [全部已读 -> all]
   */
  async setMsgRead(ids) {
    const url = `${this.wpsDomain}/msg/read`;

    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        data: {
          ids,
        },
        withCredentials: true,
      },
    });
  }

  /**
   * 上报某个资源的访问记录
   */
  async readPostItem(postType, id) {
    const url = `${this.wpsDomain}/v2/user/read/${postType}/${id}`;

    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        withCredentials: true,
      },
    });
  }

  /**
   * 获取内容的面包屑
   * @param {*} postType 教程类型
   * @param {*} postId 教程ID
   * @param {*} sid 系列课id（可选）
   */
  async getBreadcrumb(postType, postId, sid) {
    let url = `${this.cdnDomain}/v2/common/breadcrumb/${postType}/${postId}`;
    if (sid) {
      url = `${url}/${sid}`;
    }

    return handleLearningRequest(
      await httpRequest.query({
        url,
      })
    );
  }

  /**
   * 获取某内容类型下的一级~三级分类
   * @param {*} postType 内容类型
   */
  async getCategoriesMenu(postType) {
    const url = `${this.cdnDomain}/v2/common/categories_menu/${postType}`;
    return handleLearningRequest(await httpRequest.query({ url }));
  }

  /**
   * 获取列表内容
   */
  async getPostList({ postType, category, sort, page, pageSize }) {
    const url = `${this.cdnDomain}/v2/common/post_list`;
    return handleLearningRequest(
      await httpRequest.query({
        url,
        options: {
          data: {
            post_type: postType,
            category,
            sort,
            page,
            page_size: pageSize,
          },
        },
      })
    );
  }

  /**
   * 获取图书馆首页的 3 个板块运营位数据（缺少顶部 4 个图片推广位）
   */
  async getLibraryIndexTotal() {
    const url = `${this.cdnDomain}/v2/op/library_index_total`;
    return handleLearningRequest(await httpRequest.query({ url }));
  }

  /**
   * 获取某分类的信息（包括设置的对应图片资源）
   */
  async getCategoryBanner(id) {
    const url = `${this.cdnDomain}/v2/common/category/${id}`;

    return handleLearningRequest(await httpRequest.query({ url }));
  }

  /**
   * 提交详情页有无帮助评价
   */

  async submitIsHelp(data) {
    const url = `${this.wpsDomain}/comment`;
    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        data,
        withCredentials: true,
      },
    });
  }

  /**
   * 获取question详情页内容
   */
  async getQuestionDetail(id, isPreview) {
    const url = isPreview
      ? `${this.domain}/v2/common/detail/${id}?is_preview=true`
      : `${this.cdnDomain}/v2/common/detail/${id}`;
    return handleLearningRequest(
      await httpRequest.query({
        url,
      })
    );
  }

  /**
   * 获取question详情页热门问答内容
   */
  async hotQuestionDetail(id) {
    const url = `${this.cdnDomain}/v2/op/qa_total/${id}`;
    return handleLearningRequest(
      await httpRequest.query({
        url,
      })
    );
  }

  /**
   * 用户上报已学进度
   */
  async userpostread(data) {
    const url = `${this.domain}/v2/userpostread/`;
    return handleLearningRequest(
      await httpRequest.query({
        url,
        options: {
          method: 'post',
          data,
          withCredentials: true,
        },
      })
    );
  }

  /***********************************************/
  /**
   * 获取首页的数据
   */
  async getHomeData() {
    const url = `${this.cdnDomain}/v2/home/`;
    return handleLearningRequest(await httpRequest.query({url}));
  }

  /**
   * 获取office基础课[分类]列表
   */
  async getBasicCourseCategoryList() {
    const url = `${this.cdnDomain}/v2/series/category_list`;
    return handleLearningRequest(await httpRequest.query({url}));
  }

  /**
   * 获取offcie基础课[标签]列表
   */
  async getBasicCourseTagList() {
    const url = `${this.cdnDomain}/v2/series/tag_list`;
    return handleLearningRequest(await httpRequest.query({url}));
  }

  /**
   * 获取Office基础课列表
   */
  async getBasicCourseVideoList({ category_id, tag_id, sort, page, pageSize }) {
    const url = `${this.cdnDomain}/v2/series/`;
    return handleLearningRequest(
      await httpRequest.query({
        url,
        options: {
          data: {
            category_id,
            tag_id,
            sort,
            page,
            page_size: pageSize,
          },
        },
      })
    );
  }

  /**
   * 获取我的学习列表
   */
  async getUserLearning () {
    const url = `${this.domain}/v2/user_learning/?page_size=100`;
    return handleLearningRequest(
      await httpRequest.query({
        url,
        options: { withCredentials: true },
      })
    );
  }

  /**
   * 获取我的学习状态
   */
  async getUserLearningStatus(id, sid) {
    const url = `${this.domain}/v2/user_learning/get_status_and_fresh_post`;
    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        data: { last_read_post_id: id, sid },
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      },
    });
  }

  /**
   * 加入我的学习
   */
  async joinUserLearning(id, sid) {
    const url = `${this.domain}/v2/user_learning/`;
    const data = {
      last_read_post_id: Number(id), 
      sid: Number(sid),
    };
    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        data: data,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      },
    });
  }

  /**
   * 加入我的学习
   */
  async cancelUserLearning(sid) {
    const url = `${this.domain}/v2/user_learning/cancel`;
    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        data: { sid },
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      },
    });
  }
  
  /**
   * 关闭学习提醒
   */
  async changeUserLearningPushStatus(sid, status) {
    const url = `${this.domain}/v2/user_learning/push_status`;
    const data = {
      push_status: Number(status), 
      sid: Number(sid),
    };
    return await httpRequest.query({
      url,
      options: {
        method: 'patch',
        data: data,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      },
    });
  }

  /**
   * 全局关闭学习提醒
   */
  async changeUserLearningGlobalPushStatus(status) {
    const url = `${this.domain}/v2/user_config/learning_push_status`;
    const data = {
      status: Number(status), 
    };
    return await httpRequest.query({
      url,
      options: {
        method: 'patch',
        data: data,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      },
    });
  }

  /**
   * 获取系列课已学进度
   */
  async getCourseProgress (sid) {
    const url = `${this.domain}/v2/user_learning/course_progress/${sid}`;
    return await httpRequest.query({
      url,
      options: { withCredentials: true },
    });
  }

  /**
   * 上报最近的访问时间
   */
  async reportLastReadTime () {
    const url = `${this.wpsDomain}/v2/user_config/last_read_time`;
    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        withCredentials: true,
      },
    });
  }
}

export default new Learning();
